/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import NavFormIndustryDropdown from '../NavFormIndustryDropdown';

const CeReportFilter = ({ filterOptions, handleFilterSubmit, selectedFilters, setSelectedFilters }) => {
  const ceFilterRef = useRef(null);
  const [filters, setFilters] = useState({
    code: '',
    region: '',
    revenue_band: '',
    year: '',
  })

  const [options, setOptions] = useState({
    code: [],
    region: [],
    revenue_band: [],
    year: [],
  })

  const updateFilters = ({ target }) => {
    let updated = target.value;

    switch (target.name) {
        case 'code':
            setSelectedFilters(prevState => {
                return { ...prevState, code: updated }
            })
            break;
        case 'revenue_band':
            setSelectedFilters(prevState => {
                return { ...prevState, revenue_band: updated }
            })
            break;
        case 'region':
            setSelectedFilters(prevState => {
                return { ...prevState, region: updated }
            })
            break;
        case 'year':
            setSelectedFilters(prevState => {
                return { ...prevState, year: parseInt(updated) }
            })
            break;
    }
  };

  const buildFilter = ({ list, selected, key, label, styleName, optionCallback }) => {
    if (list) return (
      <div className={styleName} id={key + '-filter'}>
        <label htmlFor={key} className='text-left'>{label}</label>
        <select name={key} value={selected} onChange={updateFilters} className={`${styleName}`}>
          {list.map((filter, i) => {
            if (optionCallback) return optionCallback(filter, i);
            return (
              <option key={i} value={filter} className='option-dropdown-filter'>
                {filter}
              </option>
            );
          })}
        </select>
      </div>
    )
  }

  return (
    <form id='dropdown-filter-id' ref={ceFilterRef} onSubmit={(e) => { handleFilterSubmit(e) }}>
      <div className='mc-dropdown-filters'>
        <div>
            {selectedFilters && <NavFormIndustryDropdown selectedCode={selectedFilters.code} codeOptions={filterOptions.code} setSelectedFilters={setFilters} page='ceReports' />}
            {buildFilter({
                list: filterOptions.revenue_band,
                selected: selectedFilters.revenue_band,
                key: 'revenue_band',
                label: 'Revenue',
                styleName: 'revenue-band-filter filter-item-side-bar',
            })}
            {buildFilter({
                list: filterOptions.region,
                selected: selectedFilters.region,
                key: 'region',
                label: 'Region',
                styleName: 'region-filter filter-item-side-bar',
            })}
            {buildFilter({
                list: filterOptions.year,
                selected: selectedFilters.year,
                key: 'year',
                label: 'Calendar Year',
                styleName: 'year-filter filter-item-side-bar',
            })}
        </div>
        <button className='filters-btn-manage-clients' type='submit'>Apply Filters</button>
      </div>
    </form>
  )
}

export default CeReportFilter;

/* {buildFilter({
    list: filterOptions.ce_group,
    selected: selectedFilters.ce_group,
    key: 'ce_group',
    label: 'Group',
    styleName: 'partner-filter filter-item-side-bar',
})} */